import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ScrollControl from "./hooks/ScrollControl";
import { ThemeProvider } from "./ThemeContext";
import MainLayout from "./layouts/MainLayout";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <ScrollControl>
            <MainLayout />
          </ScrollControl>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
